var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorevalue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 60,
    stroke: "#2CEEE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_9852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2934 31.3969C72.1356 32.9969 72.9215 34.8 73.6418 36.8078C76.3278 44.3063 77.4231 52.9266 77.4231 60.8282C77.4231 81.8703 69.7028 99.6563 59.7731 99.6563C54.1496 99.6563 49.1387 93.8672 45.9059 84.8485C40.884 70.8282 40.8403 50.95 45.9059 36.8078C51.4668 21.2953 61.034 17.9782 68.3121 26.8219",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3578 82.7405C27.4495 82.0408 26.7059 81.2094 26.1473 80.2414C23.3345 75.3701 25.8431 68.1362 32.0367 60.8272C41.6478 49.4928 58.8256 39.4966 73.6415 36.807C83.0686 35.097 90.5878 36.5419 93.3992 41.4131C94.3059 42.9834 94.6606 44.8001 94.5147 46.7847",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1851 85.3044C38.2772 85.7295 41.9199 85.5711 45.9047 84.8478C63.8477 81.592 85.2554 67.5648 92.3494 53.7539",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.231 76.8398C61.831 82.1648 72.3075 85.5695 80.8591 85.5398",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6417 39.5273C27.0526 40.0867 26.5511 40.7148 26.1479 41.4148C23.3339 46.2867 25.8433 53.5195 32.037 60.8289C36.1308 65.657 41.5526 70.1977 47.537 74.0352",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2739 36.495C37.5511 35.8989 41.5219 36.0119 45.9052 36.8072C60.7867 39.5085 77.9627 49.5621 87.5085 60.8258C93.7038 68.1349 96.2122 75.3703 93.3994 80.2414C92.3028 82.1413 90.4908 83.5202 88.1281 84.3925",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4244 37.5328C34.4244 39.5675 32.7739 41.2164 30.7393 41.2164C28.6936 41.2164 27.0557 39.5537 27.0557 37.5328C27.0557 35.4981 28.7046 33.8477 30.7393 33.8477C32.7954 33.8477 34.4244 35.5228 34.4244 37.5328Z",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1591 85.7356C88.485 83.7274 87.1213 81.8353 85.1132 81.5094C83.105 81.1835 81.2129 82.5472 80.887 84.5553C80.5611 86.5635 81.9248 88.4556 83.933 88.7815C85.9411 89.1074 87.8332 87.7437 88.1591 85.7356Z",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6051 50.4234C97.6051 52.4581 95.9563 54.107 93.9215 54.107C91.8954 54.107 90.2363 52.4673 90.2363 50.4234C90.2363 48.3887 91.8868 46.7383 93.9215 46.7383C95.9449 46.7383 97.6051 48.3791 97.6051 50.4234Z",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5864 80.832C33.6211 80.832 35.2716 82.4808 35.2716 84.5156C35.2716 86.5344 33.636 88.2008 31.5864 88.2008C29.5517 88.2008 27.9028 86.5503 27.9028 84.5156C27.9028 82.4866 29.5486 80.832 31.5864 80.832Z",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7737 70.2397C64.9722 70.2397 69.1865 66.0254 69.1865 60.8269C69.1865 55.6283 64.9722 51.4141 59.7737 51.4141C54.5751 51.4141 50.3608 55.6283 50.3608 60.8269C50.3608 66.0254 54.5751 70.2397 59.7737 70.2397Z",
    stroke: "#2CEEE3",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_9852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorevalue);
export default __webpack_public_path__ + "static/media/corevalue.f6a874fed49c772451aacd38a4fad3dc.svg";
export { ForwardRef as ReactComponent };